import * as React from 'react';
import { UsersManager } from './UsersManager';
import { DepotsManager } from './DepotsManager';
import { BacsManager } from './BacsManager';
import { ProductsManager } from './ProductsManager';
import { useAuthProvider } from '../../core/context/ProvidersContext';
import styles from './AdminPanel.module.scss';

type AdminTab = 'users' | 'depots' | 'bacs' | 'products';

export const AdminPanel: React.FC = () => {
  const auth = useAuthProvider();
  const [tab, setTab] = React.useState<AdminTab>('depots');

  // Users tab is only useful when the auth provider supports login (= standalone).
  const showUsers = auth.supportsLogin;

  return (
    <div className={styles.panel}>
      <div className={styles.subTabs}>
        {showUsers && (
          <button
            className={tab === 'users' ? styles.subTabActive : styles.subTab}
            onClick={() => setTab('users')}
          >
            Utilisateurs
          </button>
        )}
        <button
          className={tab === 'depots' ? styles.subTabActive : styles.subTab}
          onClick={() => setTab('depots')}
        >
          Dépôts
        </button>
        <button
          className={tab === 'bacs' ? styles.subTabActive : styles.subTab}
          onClick={() => setTab('bacs')}
        >
          Bacs
        </button>
        <button
          className={tab === 'products' ? styles.subTabActive : styles.subTab}
          onClick={() => setTab('products')}
        >
          Produits &amp; couleurs
        </button>
      </div>

      <div className={styles.content}>
        {tab === 'users' && showUsers && <UsersManager />}
        {tab === 'depots' && <DepotsManager />}
        {tab === 'bacs' && <BacsManager />}
        {tab === 'products' && <ProductsManager />}
      </div>
    </div>
  );
};
